import {
  addMonths,
  subWeeks,
  subMonths,
  startOfMonth,
  endOfMonth,
  addWeeks,
  startOfWeek,
  endOfWeek,
  Locale,
} from 'date-fns'

import {formatDate} from 'common/helpers'

interface WeekOptions {
  locale?: Locale
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6
}

const today = new Date()

const weekOptions: WeekOptions = {
  weekStartsOn: 1,
}

const getWeekStartDate = (date: Date): Date => startOfWeek(date, weekOptions)
const getWeekEndDate = (date: Date): Date => endOfWeek(date, weekOptions)

export const CURRENT_WEEK_PERIOD = (() => {
  const startDate = getWeekStartDate(today)
  const endDate = getWeekEndDate(today)
  return {
    key: 'currentWeek',
    label: 'Current week',
    tip: `${formatDate(startDate, 'fifth')} - ${formatDate(endDate, 'fifth')}`,
    period: {
      dateFrom: formatDate(startDate, 'server'),
      dateTo: formatDate(endDate, 'server'),
    },
  }
})()

export const PREV_WEEK_PERIOD = (() => {
  const prevWeekDate = subWeeks(today, 1)
  const startDate = getWeekStartDate(prevWeekDate)
  const endDate = getWeekEndDate(prevWeekDate)
  return {
    key: 'prevWeek',
    label: 'Previous week',
    tip: `${formatDate(startDate, 'fifth')} - ${formatDate(endDate, 'fifth')}`,
    period: {
      dateFrom: formatDate(startDate, 'server'),
      dateTo: formatDate(endDate, 'server'),
    },
  }
})()

export const PREV_MONTH_PERIOD = (() => {
  const prevMonthDate = subMonths(today, 1)
  return {
    key: 'prevMonth',
    label: 'Previous month',
    tip: formatDate(prevMonthDate, 'eight'),
    period: {
      dateFrom: formatDate(startOfMonth(prevMonthDate), 'server'),
      dateTo: formatDate(endOfMonth(prevMonthDate), 'server'),
    },
  }
})()

export const PREV_TWO_MONTHS_PERIOD = (() => {
  const startDate = startOfMonth(subMonths(today, 2))
  const endDate = endOfMonth(subMonths(today, 1))
  return {
    key: 'prevMonths',
    label: 'Previous 2 months',
    tip: `${formatDate(startDate, 'fourth')} - ${formatDate(
      endDate,
      'fourth'
    )}`,
    period: {
      dateFrom: formatDate(startDate, 'server'),
      dateTo: formatDate(endDate, 'server'),
    },
  }
})()

export const NEXT_WEEK_PERIOD = (() => {
  const nextWeekDate = addWeeks(today, 1)
  const startDate = getWeekStartDate(nextWeekDate)
  const endDate = getWeekEndDate(nextWeekDate)
  return {
    key: 'nextWeek',
    label: 'Upcoming week',
    tip: `${formatDate(startDate, 'fifth')} - ${formatDate(endDate, 'fifth')}`,
    period: {
      dateFrom: formatDate(startDate, 'server'),
      dateTo: formatDate(endDate, 'server'),
    },
  }
})()

export const NEXT_MONTH_PERIOD = (() => {
  const nextMonthDate = addMonths(today, 1)
  return {
    key: 'nextMonth',
    label: 'Upcoming month',
    tip: formatDate(nextMonthDate, 'eight'),
    period: {
      dateFrom: formatDate(startOfMonth(nextMonthDate), 'server'),
      dateTo: formatDate(endOfMonth(nextMonthDate), 'server'),
    },
  }
})()

export const NEXT_TWO_MONTHS_PERIOD = (() => {
  const startDate = startOfMonth(addMonths(today, 1))
  const endDate = endOfMonth(addMonths(today, 2))

  return {
    key: 'nextMonths',
    label: 'Upcoming 2 months',
    tip: `${formatDate(startDate, 'fourth')} - ${formatDate(
      endDate,
      'fourth'
    )}`,
    period: {
      dateFrom: formatDate(startDate, 'server'),
      dateTo: formatDate(endDate, 'server'),
    },
  }
})()
